export const GAME_IDEA_PLACEHOLDERS = [
  "A racing game where snails ride rockets...",
  "A cooking game where cats run a 5-star restaurant...",
  "A puzzle game about librarians fighting book-eating monsters...",
  "A platformer where clouds learn to make rain...",
  "An adventure game starring a coffee bean finding its way home...",
  "A strategy game where plants plot to take over the city...",
  "A simulation where penguins manage a beach resort...",
  "A mystery game where postcards solve crimes...",
  "An RPG about a sock searching for its lost pair...",
  "A management game where ghosts run a theme park...",
  "A card game where foods compete in a talent show...",
  "A building game where squirrels design treehouses...",
  "A stealth game where grandmas are secret superheroes...",
  "A rhythm game where vegetables form a rock band...",
  "A farming sim where aliens learn Earth agriculture...",
  "A tower defense where soap bubbles fight germs...",
  "A dungeon crawler where office supplies come alive at night...",
  "A survival game where umbrellas explore a paper world...",
  "A sports game where clouds compete in shape-shifting contests...",
  "A dating sim where tea flavors find their perfect blend...",
  "A city builder where lost socks create an underground civilization...",
  "A racing game where colors compete to paint the sunset...",
  "A battle royale where different types of pasta fight to be dinner...",
  "A puzzle game where dreams organize a sleeping mind...",
  "A crafting game where origami animals run a post office...",
  "A time management game where seasons work at a weather factory...",
  "An exploration game where forgotten toys search for new homes...",
  "A detective game where mirror reflections solve mysteries...",
  "A party game where emotions compete in a theme park...",
  "A strategy game where garden gnomes wage tiny wars...",
  "A card game where constellations trade shooting stars...",
  "A fishing game where mermaids collect human artifacts..."
]; 